export const BUSINESS_USER_PAGE = '/business/memberships/users'

export const FOOTER_LEFT_NAV_ITEMS = [
  {
    category: 'バヅクリについて',
    navItems: [
      {
        text: 'バヅクリとは',
        href: '/about',
        target: '_self',
      },
      {
        text: '人的資本とエンゲージメント',
        href: '/human_capital_engagement',
        target: '_self',
      },
    ],
  },
  {
    category: 'サービス',
    navItems: [
      {
        text: 'エンゲージメント改善',
        href: 'https://hr.buzzkuri.com/engagement',
        target: '_blank',
      },
      {
        text: '内定者フォロー',
        href: 'https://tb.buzzkuri.com/naiteisha/',
        target: '_blank',
      },
      {
        text: '社内イベント 組合レク',
        href: 'https://tb.buzzkuri.com/event/',
        target: '_blank',
      },
      {
        text: '研修',
        href: 'https://hr.buzzkuri.com/training',
        target: '_blank',
      },
    ],
    subNabItems: [
      {
        text: 'プログラム一覧',
        href: '/programs',
        target: '_self',
      },
      {
        text: '講師一覧',
        href: '/lecturers',
        target: '_self',
      },
      {
        text: '導入事例',
        href: '/cases',
        target: '_self',
      },
      {
        text: '料金プラン',
        href: '/prices',
        target: '_self',
      },
      {
        text: 'よくある質問',
        href: '/questions',
        target: '_self',
      },
    ],
  },
  {
    category: 'メディア・プログラム',
    navItems: [
      {
        text: 'バヅクリ HR研究所',
        href: 'https://buzzkuri.com/columns/',
        target: '_blank',
      },
      {
        text: '資料ダウンロード',
        href: 'https://download.buzzkuri.com/document',
        target: '_blank',
      },
      {
        text: 'お役立ち資料',
        href: 'https://download.buzzkuri.com/whitepaper',
        target: '_blank',
      },
    ],
  },
  {
    category: 'その他',
    navItems: [
      {
        text: '運営会社',
        href: 'https://buzzkuri.co.jp/',
        target: '_blank',
      },
      {
        text: '会員権サービス利用規約',
        href: '/business-term',
        target: '_self',
      },
      {
        text: 'エンゲージメントサーベイ利用規約',
        href: '/survey-term',
        target: '_self',
      },
      {
        text: 'プライバシーポリシー',
        href: 'https://buzzkuri.co.jp/privacy',
        target: '_self',
      },
      {
        text: '販売パートナー募集',
        href: 'https://download.buzzkuri.com/salespartner',
        target: '_blank',
      },
    ],
  },
]
